<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH ĐĂNG KÝ DÒNG HỌ</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="3">
                      <el-form-item label="Tên dòng họ">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['ten_dong_ho']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Họ tên">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['ho_ten']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Điện thoại">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['dien_thoai']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Email">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['email']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="3">
                      <el-form-item label="Ngày đăng kí">
                        <el-date-picker
                          v-model="
                            mData.tableRules.dataSearch.value['thoi_diem_tao']
                          "
                          type="daterange"
                          range-separator="-"
                          format="dd/MM/yyyy"
                          start-placeholder="Từ ngày"
                          end-placeholder="Đến ngày"
                          @input="$forceUpdate()"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-above">
            <b-row>
              <b-col lg="4">
                <el-select
                  v-model="mData.tableRules.dataSearch.value['trang_thai']"
                  multiple
                  placeholder="Trạng thái"
                  @change="fn_changeTrangThai"
                  size="medium"
                  clearable
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </b-col>
            </b-row>
          </div>
          <div class="main-body-table">
            <el-table
              :data="mData.tableRules.data"
              :row-class-name="tableRowClassName"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column width="150" prop="trang_thai" label="Trạng thái">
                <template slot="header" slot-scope="">
                  <div>Trạng thái</div>
                </template>

                <template slot-scope="scope">
                  <div
                    v-if="scope.row.trang_thai == 'dang_cho'"
                    class="text-box"
                  >
                    <p>Chờ duyệt</p>
                  </div>
                  <div
                    v-if="scope.row.trang_thai == 'tu_choi'"
                    class="text-box"
                  >
                    <p>Từ chối</p>
                  </div>
                  <div
                    v-if="scope.row.trang_thai == 'da_duyet'"
                    class="text-box"
                  >
                    <p>Đã duyệt</p>
                  </div>
                  <div
                    v-if="scope.row.trang_thai == 'dang_xu_ly'"
                    class="text-box"
                  >
                    <p>Đang xử lý</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ten_dong_ho"
                label="Tên dòng họ"
                min-width="150"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="slotData">
                  <p v-if="!slotData.row.ma_gioi_thieu">
                    {{ slotData.row.ten_dong_ho }}
                  </p>
                  <p v-else>
                    {{ slotData.row.ten_dong_ho }} (<span
                      class="referral-code"
                      >{{ slotData.row.ma_gioi_thieu || "1236873128673" }}</span
                    >)
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="Địa chỉ" min-width="280">
                <template slot-scope="slotData">
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content">{{ slotData.row.dia_chi }}</div>
                    <span>{{ slotData.row.dia_chi }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="ho_ten"
                label="Họ tên"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="dien_thoai"
                label="Điện thoại"
                align="center"
                width="110"
              ></el-table-column>
              <el-table-column
                prop="email"
                label="Email"
                align="center"
                min-width="150"
              ></el-table-column>

              <el-table-column
                prop="thoi_diem_tao"
                label="Thời điểm đăng kí"
                align="center"
                width="160"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      fn_date(scope.row.thoi_diem_tao),
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="120px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="far fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormDangKyDongHo";
import mushroom from "viettoc-api";
import eventBus from "../../../service/EventBus";
import moment from "moment";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      dieuKienLoc: "",
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
        trangThai: MethodService.copyObject(DataForm.trangThai),
      },
      options: [
        {
          value: "dang_cho",
          label: "Chờ duyệt",
        },
        {
          value: "da_duyet",
          label: "Đã duyệt",
        },

        {
          value: "tu_choi",
          label: "Từ chối",
        },
        {
          value: "dang_xu_ly",
          label: "Đang xử lý",
        },
      ],
    };
  },
  components: {
    Circle4,
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (
        Number(row.delayChoDuyet) > 1 &&
        Number(row.delayChoDuyet) <= 2 &&
        row.trang_thai === "dang_cho"
      ) {
        return "delayYellow";
      }
      if (
        Number(row.delayXuLy) > 1 &&
        Number(row.delayXuLy) <= 2 &&
        row.trang_thai === "dang_xu_ly"
      ) {
        return "delayYellow";
      }
      if (
        Number(row.delayChoDuyet) > 2 &&
        Number(row.delayChoDuyet) <= 7 &&
        row.trang_thai === "dang_cho"
      ) {
        return "delayRed";
      }
      if (
        Number(row.delayXuLy) > 2 &&
        Number(row.delayXuLy) <= 7 &&
        row.trang_thai === "dang_xu_ly"
      ) {
        return "delayRed";
      }
      if (Number(row.delayChoDuyet) > 7 && row.trang_thai === "dang_cho") {
        return "delayPub";
      }
      if (Number(row.delayXuLy) > 7 && row.trang_thai === "dang_xu_ly") {
        return "delayPub";
      }
    },
    async fn_initTable(filter) {
      let dataFilter = {
        filters: filter,
        fields:
          "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,trong_ho,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_xet_duyet,nguoi_xet_duyet,ma_gioi_thieu",
        //sort: "-thoi_diem_tao",
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
        dataFilter.filters = this.mData.tableRules.filters;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachDangKyDongHo",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }

      try {
        const response = await mushroom.dang_ky.listAsync(dataFilter, {
          cacheAge: 1,
        });
        console.log("danh sách dòng họ đăng ký: ", response.result);
        if (response.result) {
          let today = new Date();
          response.result.forEach(async (item) => {
            // tính ngày chờ duyệt
            let dayDk = new Date(item.thoi_diem_tao);
            item.delayChoDuyet =
              (today.getTime() - dayDk.getTime()) / (1000 * 3600 * 24);

            // tính ngày chờ xử lý: bằng thời điểm phản hồi mới nhất trừ đi thời điểm chuyển trạng thái đang xử lý
            item.delayXuLy = 0;
            const timePhanHoiMoiNhat =
              await mushroom.dang_ky_phan_hoi.listAsync({
                fields:
                  "id,dang_ky_id,noi_dung,nguoi_gui,thoi_diem_tao,nguoi_tao_id",
                filters: ["dang_ky_id=" + item.id],
                sort: "-thoi_diem_tao",
              });

            if (
              timePhanHoiMoiNhat.result &&
              timePhanHoiMoiNhat.result.length > 0
            ) {
              item.delayXuLy =
                (today.getTime() -
                  new Date(
                    timePhanHoiMoiNhat.result[0].thoi_diem_tao
                  ).getTime()) /
                (1000 * 3600 * 24);
            } else item.delayXuLy = 0;
          });
          this.loading = false;
          let resData = await this.fn_changeData(response.result);
          console.log("resData", resData);
          this.mData.tableRules.data = resData;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
          eventBus.$emit("duyetDangKyDongHo");
        }
      } catch (e) {
        console.log(e.code);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        }
      }
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable(this.mData.tableRules.filters);
    },
    fn_changeTrangThai(item) {
      localStorage.setItem("trang_thai", "trang_thai=" + item);
      this.fn_tableSearch();
    },
    fn_date(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    async fn_changeData(data) {
      data.forEach(async (element) => {
        element.dien_thoai = MethodService.formatPhone(element.dien_thoai);
        let diachi = element.dia_chi;
        let responseTinh = "";
        let responseHuyen = "";
        let responseXa = "";

        let maQuocGia = "";
        if (element.quoc_gia_id) {
          try {
            const response = await mushroom.quoc_gia.findByIdAsync({
              id: element.quoc_gia_id,
            });
            console.log("Thông tin quoc_gia trả về: %o", response);
            if (response.result && response.result.ma.alpha_2 !== "VN")
              diachi = diachi + ", " + response.result.ten_quoc_gia.vi;
            maQuocGia = response.result.ma.alpha_2;
          } catch (e) {
            console.error("Có lỗi: %o", e);
          }
        }

        if (!element.quoc_gia_id || maQuocGia === "VN") {
          if (element.xa_id) {
            responseXa = await mushroom.commune.listAsync({
              filters: ["id=" + element.xa_id],
            });
            diachi =
              diachi +
              ", " +
              responseXa.result[0].type +
              " " +
              responseXa.result[0].name;
          }
          if (element.huyen_id) {
            responseHuyen = await mushroom.district.listAsync({
              filters: ["id=" + element.huyen_id],
            });
            diachi =
              diachi +
              ", " +
              responseHuyen.result[0].type +
              " " +
              responseHuyen.result[0].name;
          }
          if (element.tinh_id) {
            responseTinh = await mushroom.province.listAsync({
              filters: ["id=" + element.tinh_id],
            });
            console.log("responseTinh", responseTinh);
            diachi =
              diachi +
              ", " +
              responseTinh.result[0].type +
              " " +
              responseTinh.result[0].name;
          }
        }
        element.dia_chi = diachi;
      });
      return data;
    },
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );

        // riêng phần này cần giữ lại điều kiện lọc bên ngoài form search
        // chuyển điều kiện lọc từ chuỗi sang mảng để fill ô lọc
        this.mData.tableRules.dataSearch.value.trang_thai =
          this.mData.tableRules.dataSearch.value.trang_thai.split(",");
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable(this.mData.tableRules.filters);
    },

    // xem chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietDangKyDongHo",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "DuyetDangKyDongHo",
          params: { id: row.id },
        });
      }
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;

      this.$router.replace({
        name: "DanhSachDangKyDongHo",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });

      this.fn_initTable(this.mData.tableRules.filters);
    },
    async fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["ten_dong_ho"]) {
        this.mData.tableRules.dataSearch.value["ten_dong_ho"] =
          this.mData.tableRules.dataSearch.value["ten_dong_ho"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["ho_ten"]) {
        this.mData.tableRules.dataSearch.value["ho_ten"] =
          this.mData.tableRules.dataSearch.value["ho_ten"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["dien_thoai"]) {
        if (
          this.mData.tableRules.dataSearch.value["dien_thoai"].slice(0, 1) == 0
        ) {
          this.mData.tableRules.dataSearch.value["dien_thoai"] =
            "84" +
            this.mData.tableRules.dataSearch.value["dien_thoai"].slice(1, 10);
        } else {
          this.mData.tableRules.dataSearch.value["dien_thoai"] =
            this.mData.tableRules.dataSearch.value["dien_thoai"].trim();
        }
      }
      if (this.mData.tableRules.dataSearch.value["email"]) {
        this.mData.tableRules.dataSearch.value["email"] =
          this.mData.tableRules.dataSearch.value["email"].trim();
      }
      MethodService.stopLadda();
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.page = 1;
          // this.mData.tableRules.sort = "";
          this.dieuKienLoc = this.mData.tableRules.filters;
          this.fn_initTable(this.dieuKienLoc);
          if (
            this.mData.tableRules.dataSearch.value["dien_thoai"] &&
            this.mData.tableRules.dataSearch.value["dien_thoai"].slice(0, 2) ==
              84
          ) {
            this.mData.tableRules.dataSearch.value["dien_thoai"] =
              "0" +
              this.mData.tableRules.dataSearch.value["dien_thoai"].slice(2, 12);
          }

          MethodService.stopLadda();
          localStorage.getItem("tim_kiem", this.dieuKienLoc);
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
    // async refreshData() {
    //   await this.fn_initTable("trang_thai:in:dang_xu_ly,dang_cho");
    //   setTimeout(() => {
    //     this.refreshData();
    //   }, 300000);
    // },
  },
  //run after render view
  async created() {
    await this.fn_hashUrl();
    //await this.refreshData();
    await this.fn_initTable("trang_thai:in:dang_xu_ly,dang_cho");
  },
};
</script>

<style scoped lang="scss">
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}
@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
.text-box {
  display: flex;
  justify-content: center;
}

.colorPub,
::v-deep .delayPub {
  background-color: #8443ff;
}

.loadingPage {
  position: absolute;
  z-index: 10;
  height: 100%;
  width: 100%;
  background-color: #fff;
}
.main-body-table {
  position: relative;
}
.main-body-above {
  margin: 5px 2px;
}

label {
  margin-bottom: 0;
}
::v-deep .el-table tbody tr:nth-of-type(even) {
  background-color: transparent;
}
::v-deep .delayYellow {
  background-color: #f7f097 !important;
}

::v-deep .delayRed {
  background-color: #ff8a7d !important;
}
::v-deep .delayPub {
  background-color: #dcaef1 !important;
}
::v-deep .delayYellow,
::v-deep .delayPub,
::v-deep .delayRed {
  font-size: 13px;
  color: #606266;
}

::v-deep .el-table td.el-table__cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #d4d4d4;
}
::v-deep .el-table--border .el-table__cell,
::v-deep
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-right: 1px solid #d4d4d4;
}
::v-deep .el-table__body tr.el-table__row:hover > td {
  background-color: inherit;
}
.referral-code {
  font-style: italic;
  font-size: 12px;
}
</style>
